var _circle, _circle2, _ellipse, _ellipse2, _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgGenderFemale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 70,
    viewBox: "0 0 62 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.6487,
    cy: 6.86961,
    r: 6.86961,
    fill: "#333B4F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.649,
    cy: 39.3512,
    r: 30.649,
    fill: "#FFE8DB"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1939,
    cy: 45.6916,
    rx: 2.11373,
    ry: 3.17059,
    fill: "#262626"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.1037,
    cy: 45.6916,
    rx: 2.11373,
    ry: 3.17059,
    fill: "#262626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8763 53.0889H25.8929C25.8929 55.2026 27.4782 56.7879 30.6488 56.7879C33.6381 56.7879 34.7001 54.498 34.8763 53.0889Z",
    fill: "#F09387"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0372196 40.875L21.6973 28.3977C27.8273 32.6546 42.7459 37.1415 61.2337 41.3536C61.2764 40.6917 61.298 40.0239 61.298 39.3512C61.298 22.4242 47.576 8.70215 30.649 8.70215C13.722 8.70215 0 22.4242 0 39.3512C0 39.8621 0.012503 40.3701 0.0372196 40.875Z",
    fill: "#333B4F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.2991,
    y: 7.84766,
    width: 1.73275,
    height: 13.2971,
    transform: "rotate(90.1045 37.2991 7.84766)",
    fill: "#FF8282"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgGenderFemale);
export default __webpack_public_path__ + "static/media/img_gender_female.bef92037191b9957a1d8e9f51f30367b.svg";
export { ForwardRef as ReactComponent };